/* Buybox Replo copiado (landings de produto): o runtime do Replo nao vem junto, entao:
   - cada radiogroup de ofertas troca a selecao (a classe-modificadora do card que nasceu
     selecionado passa para o card clicado);
   - a quantidade de cada oferta sai do titulo ("BUY 1 GET 1 FREE" = 2, "Buy 3 + Get 2 FREE" = 5);
   - "Add To Cart" poe a quantidade da oferta selecionada no carrinho e abre a gaveta;
     "Buy it Now" faz o mesmo e segue para o checkout.
   O desconto de cada oferta e cobrado por descontos automaticos da loja (setup_discounts.py). */
(function () {
  if (window.__clReplo) return;
  window.__clReplo = true;

  function qtyOf(card) {
    var t = (card.textContent || '').replace(/\s+/g, ' ');
    var m = /buy\s*(\d+)\s*\+?\s*get\s*(\d+)/i.exec(t);
    if (m) return Number(m[1]) + Number(m[2]);
    m = /buy\s*(\d+)/i.exec(t);
    return m ? Number(m[1]) : 1;
  }

  function init(root) {
    // assinatura (selling plan) nao existe nesta loja: a aba "Automatic Refills" nao e oferecida
    [].forEach.call(root.querySelectorAll('[role="button"], button'), function (b) {
      if (/automatic refills/i.test(b.textContent || '')) { b.style.visibility = 'hidden'; b.style.pointerEvents = 'none'; }
    });
    var groups = [].slice.call(root.querySelectorAll('[role="radiogroup"]'));
    groups.forEach(function (g) {
      var cards = [].slice.call(g.children).filter(function (c) { return c.getAttribute('role') === 'button'; });
      if (!cards.length) return;
      var sel = cards.find(function (c) { return c.classList.length > 1; }) || cards[0];
      var mod = [].slice.call(sel.classList).slice(1);
      sel.setAttribute('data-cl-selected', '');
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (o) {
            mod.forEach(function (k) { o.classList.remove(k); });
            o.removeAttribute('data-cl-selected');
          });
          mod.forEach(function (k) { c.classList.add(k); });
          c.setAttribute('data-cl-selected', '');
        });
      });
    });
  }

  function selectedQty(btn) {
    var box = btn.closest('[data-cl-replo]');
    var groups = [].slice.call(box.querySelectorAll('[role="radiogroup"]'));
    // grupo visivel mais proximo ANTES do botao
    var best = null;
    groups.forEach(function (g) {
      if (!g.offsetParent) return;
      if (g.compareDocumentPosition(btn) & Node.DOCUMENT_POSITION_FOLLOWING) best = g;
    });
    var c = best && best.querySelector('[data-cl-selected]');
    return c ? qtyOf(c) : 1;
  }

  function add(btn, checkout) {
    var box = btn.closest('[data-cl-replo]');
    var id = Number(box.getAttribute('data-cl-variant') || window.__clReploVariant);
    var q = selectedQty(btn);
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert((res.j && (res.j.description || res.j.message)) || 'Could not add to cart'); return; }
        if (checkout) { window.location.href = '/checkout'; return; }
        if (window.clCartDrawer) window.clCartDrawer.refresh(true);
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .finally(function () { btn.classList.remove('loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cl-replo] [data-replo-add-product-variant-to-cart], [data-cl-replo] button');
    if (!btn) return;
    var label = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (label.indexOf('add to cart') !== 0 && label.indexOf('buy it now') !== 0) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(btn, label.indexOf('buy it now') === 0);
  }, true);

  /* carrossel Replo: a pista chega com o translate3d do DESKTOP congelado pelo extract e com
     clones do loop (data-slide-index < 0 e >= n). Recoloca o slide ativo pela largura REAL e
     liga os nav-button (data-direction next/previous). */
  function carousel(track) {
    if (track.__cl) return; track.__cl = true;
    var slides = [].slice.call(track.children).filter(function (s) { return s.getAttribute('data-replo-part') === 'slide'; });
    var n = new Set(slides.map(function (s) { return s.getAttribute('data-slide-source-index'); })).size || 1;
    var pos = track.getAttribute('data-active-slide-position') || 'start';
    var cur = 0;
    var host = track, navs = [];
    for (var i = 0; i < 8 && host && !navs.length; i++) {
      host = host.parentElement;
      if (host) navs = [].slice.call(host.querySelectorAll('[data-replo-part="nav-button"]'));
    }
    var live = host && host.querySelector('.replo-sr-only');
    function slideAt(k) { return slides.find(function (s) { return s.getAttribute('data-slide-index') === String(k); }); }
    function size() {
      // largura do slide = (largura visivel - gaps) / slides por pagina, como o runtime do Replo
      var spp = parseFloat(getComputedStyle(track).getPropertyValue('--replo-carousel-slides-per-page')) || 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var clipW = track.parentElement.clientWidth;
      // so quando a largura congelada do desktop nao cabe (mobile); no desktop ela ja vem certa
      if (!slides[0] || slides[0].offsetWidth <= clipW + 1) return;
      var w = (clipW - gap * (Math.ceil(spp) - 1)) / spp;
      slides.forEach(function (s) { s.style.width = w + 'px'; s.style.minWidth = w + 'px'; s.style.maxWidth = w + 'px'; });
    }
    function place(anim) {
      size();
      var s = slideAt(cur); if (!s) return;
      var x = s.offsetLeft - (slides[0] ? slides[0].offsetLeft : 0);
      if (pos === 'center') x -= (track.parentElement.clientWidth - s.offsetWidth) / 2;
      track.style.transitionProperty = 'transform';
      track.style.transitionDuration = anim ? '300ms' : '0ms';
      track.style.transform = 'translate3d(' + (-x) + 'px, 0px, 0px)';
      if (live) live.textContent = 'Slide ' + (((cur % n) + n) % n + 1) + ' of ' + n;
    }
    function go(d) {
      cur += d; place(true);
      if (cur >= n || cur < 0) {
        setTimeout(function () { cur = ((cur % n) + n) % n; place(false); }, 320);
      }
    }
    navs.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        go(b.getAttribute('data-direction') === 'previous' ? -1 : 1);
      });
    });
    // dots ("Go to slide N"): a classe extra do dot ativo passa para o clicado
    var dots = host ? [].slice.call(host.querySelectorAll('[aria-label^="Go to slide"]')) : [];
    var dotOn = dots.length ? [].slice.call((dots.find(function (d) { return d.getAttribute('aria-current') === 'true'; }) || dots[0]).classList).filter(function (c) {
      return !dots.every(function (d) { return d.classList.contains(c); });
    }) : [];
    function paintDots() {
      var k = ((cur % n) + n) % n;
      dots.forEach(function (d, j) {
        d.setAttribute('aria-current', j === k ? 'true' : 'false');
        dotOn.forEach(function (c) { d.classList.toggle(c, j === k); });
      });
    }
    dots.forEach(function (d, j) {
      d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); cur = j; place(true); paintDots(); });
    });
    var _go = go;
    go = function (d) { _go(d); paintDots(); setTimeout(paintDots, 330); };
    // swipe: toque (touch events, sem pointer capture -- o lostpointercapture do filho borbulha
    // e encerrava o gesto no 2o move) e arraste de mouse. So o gesto HORIZONTAL e capturado.
    var vp = track.parentElement, x0 = 0, y0 = 0, dx = 0, horiz = null, down = false, moved = false, base = 0;
    function curX() { var m = /translate3d\((-?[\d.]+)px/.exec(track.style.transform || ''); return m ? parseFloat(m[1]) : 0; }
    function start(x, y) { down = true; x0 = x; y0 = y; dx = 0; horiz = null; base = curX(); track.style.transitionDuration = '0ms'; }
    function move(x, y, ev) {
      if (!down) return;
      dx = x - x0; var dy = y - y0;
      if (horiz === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horiz = Math.abs(dx) > Math.abs(dy);
      if (!horiz) return;
      if (ev && ev.cancelable) ev.preventDefault();
      moved = true;
      track.style.transform = 'translate3d(' + (base + dx) + 'px, 0px, 0px)';
    }
    function end() {
      if (!down) return; down = false;
      if (horiz && Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); else place(true);
      setTimeout(function () { moved = false; }, 80);
    }
    vp.addEventListener('touchstart', function (e) { var t = e.touches[0]; start(t.clientX, t.clientY); }, { passive: true });
    vp.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
    vp.addEventListener('touchend', end); vp.addEventListener('touchcancel', end);
    vp.addEventListener('mousedown', function (e) { if (e.button === 0) { e.preventDefault(); start(e.clientX, e.clientY); } });
    window.addEventListener('mousemove', function (e) { if (down) move(e.clientX, e.clientY, e); });
    window.addEventListener('mouseup', end);
    vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    vp.style.touchAction = 'pan-y';
    place(false);
    window.addEventListener('resize', function () { place(false); });
  }

  /* colapsavel Replo (Radix): o runtime desmonta o painel fechado; o conteudo vem do SSR do
     concorrente (replo_fix.py) dentro do .replo-animated[hidden]. Aqui so alterna o estado. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-replo-collapsible] > [role="button"][aria-controls]');
    if (!b) return;
    var w = b.parentElement, open = w.getAttribute('data-state') !== 'open';
    var c = w.querySelector(':scope > .replo-animated') || document.getElementById(b.getAttribute('aria-controls'));
    var group = w.parentElement;
    if (open && group && group.getAttribute('data-cl-single') !== '0') {
      [].forEach.call(group.querySelectorAll(':scope > [data-replo-collapsible][data-state="open"]'), function (o) {
        if (o === w) return;
        o.setAttribute('data-state', 'closed');
        var ob = o.querySelector(':scope > [role="button"]'); if (ob) ob.setAttribute('aria-expanded', 'false');
        var oc = o.querySelector(':scope > .replo-animated'); if (oc) { oc.setAttribute('data-state', 'closed'); oc.hidden = true; }
      });
    }
    w.setAttribute('data-state', open ? 'open' : 'closed');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (c) { c.setAttribute('data-state', open ? 'open' : 'closed'); c.hidden = !open; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('[data-replo-collapsible] > [role="button"][aria-controls]');
    if (b) { e.preventDefault(); b.click(); }
  });

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-cl-replo]'), init);
    [].forEach.call(document.querySelectorAll('[data-cl-replo] [data-replo-part="slide-track"]'), carousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
